import { VirtualWarningBannerProps } from '.';
import { Wrapper } from 'components/wrapper';
import styles from './VirtualWarningBanner.module.scss';
import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';
import useWindowSize from 'hooks/useWindowSize';
import { useTypedSelector } from 'lib/centralStore';

export const VirtualWarningBanner = ({ children, noPaddingRight, className }: VirtualWarningBannerProps) => {
  const { isMobile } = useWindowSize();

  const isOpen = useTypedSelector(selectIsOpenCarrello);

  return (
    <Wrapper
      bgColorTransparent
      classNameWrapper={className}
      noPaddingLeft
      noPaddingRight={isMobile || isOpen || noPaddingRight}
      noPaddingTop
    >
      <div className={styles.text}>{children}</div>
    </Wrapper>
  );
};
